import { Stack, Text } from "@skailer-com/uikit";
import { ReactNode } from "react";
import { Link } from "react-router-dom";
import { twMerge } from "tailwind-merge";

export interface BreadcrumbsItem {
  id?: string | number;
  title: ReactNode;
  to?: string;
}

interface BreadcrumbsProps {
  items: BreadcrumbsItem[];
  separator?: ReactNode;
  className?: string;
}

export const Breadcrumbs = ({ items, separator = "/", className }: BreadcrumbsProps) => {
  const visibleItems = items.filter((item) => item.title !== null && item.title !== undefined);

  if (visibleItems.length === 0) {
    return null;
  }

  return (
    <Stack
      direction={"horizontal"}
      items={"center"}
      gap={"xs"}
      className={twMerge("min-w-0 flex-wrap text-lg font-semibold", className)}
    >
      {visibleItems.map((item, index) => (
        <Stack
          key={item.id ?? index}
          direction={"horizontal"}
          items={"center"}
          gap={"xs"}
          className={"min-w-0"}
        >
          <Text className={"min-w-0"}>
            {item.to ? (
              <Link to={item.to} className={"text-current no-underline hover:underline"}>
                {item.title}
              </Link>
            ) : (
              item.title
            )}
          </Text>
          {index < visibleItems.length - 1 && <Text aria-hidden={"true"}>{separator}</Text>}
        </Stack>
      ))}
    </Stack>
  );
};
